<template>
  <div class="suspension">
    <div class="top" :class="{ hover: this.$route.name == 'home' }">
      <div @mouseenter="showQrocde = true" @mouseleave="showQrocde = false" class="nav-item">
        <button class="nav-btn">
          <img src="@/assets/img/wechat-icon.png" alt="" />
          <span class="nav-btn-text">
            业务咨询
          </span>
        </button>
        <div v-if="this.$store.state.siteInfo.QRCode" class="qrcode-box"
          :style="{ display: showQrocde ? 'block' : 'none' }">
          <img :src="this.$store.state.siteInfo.QRCode" class="qrcode-img" />
        </div>
      </div>
      <el-popover class="box-item" trigger="hover" placement="left">
        <template #reference>
          <div style="borderBottom:1px solid #E8E8E8" class="nav-item">
            <button class="nav-btn">
              <img src="@/assets/img/message-icon.png" alt="" />
              <span class="nav-btn-text">
                网上留言
              </span>
            </button>
          </div>
        </template>
        <template #default>
          <div class="feedback">
            <div class="top">在线留言</div>
            <div class="bot">
              <div class="line clearfix">
                <div class="input"><input v-model="form.RealName" type="text" placeholder="姓名"></div>
                <div class="input ml10"><input v-model="form.Phone" type="text" placeholder="联系方式"></div>
              </div>
              <div class="textarea mt10"><textarea v-model="form.Body" placeholder="留言内容"></textarea></div>
              <div class="line mt10 clearfix">

              </div> <el-button @click="handlesubmit" type="primary" class="sub-btn">提交留言</el-button>
            </div>
          </div>
        </template>
      </el-popover>
      <!-- <div @mouseenter="showForm = true" @mouseleave="showForm = false" class="nav-item">
        <button class="nav-btn">
          <img src="@/assets/img/message-icon.png" alt="" />
          <span class="nav-btn-text">
            网上留言
          </span>
        </button>

      </div> -->
      <div class="nav-item">
        <button class="nav-btn" style="cursor: pointer;" @click="backTop">
          <img src="@/assets/img/back-top.png" alt="" />
          <span class="nav-btn-text">
            返回顶部
          </span>
        </button>
      </div>
    </div>
    <!-- <div class="box" v-if="boxStatic">
        <router-link to="/LearningBox">
          <img class="bg" src="@/assets/img/1.png" alt="" />
        </router-link>
        <img @click="close" class="close" src="@/assets/img/49.png" alt="" />
      </div> -->
  </div>
</template>

<script>
import Bus from "@/util/bus";
import { LeaveMessage } from '@/api/common'
export default {
  name: "RightSuspension",
  components: {},
  data() {
    return {
      arr: [],
      showForm: false,
      showQrocde: false,
      aniHeight: "490px",
      form: {
        RealName: '',
        Phone: '',
        Body: '',
      },
      boxStatic: true,
    };
  },
  methods: {
    generateRandomString() {
      const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
      let result = '';

      for (let i = 0; i < 10; i++) {
        result += chars.charAt(Math.floor(Math.random() * chars.length));
      }

      return result;
    },
    handlesubmit() {
      if (!this.form.RealName) {
        return this.$message.warning("请输入姓名");
      }
      if (!this.form.Phone) {
        return this.$message.warning("请输入手机号");
      }
      if (!this.form.Body) {
        return this.$message.warning("请输入留言内容");
      }
      let uid = ''
      if (window.localStorage.getItem('UUID')) {
        uid = window.localStorage.getItem('UUID')
      } else {
        uid = this.generateRandomString()
        uid = window.localStorage.setItem('UUID', uid)

      }
      let data = {
        ...this.form,
        'UUID': uid
      }
      LeaveMessage(data).then((res) => {
        this.$message.success("提交成功！");
        this.form = {}
      })
    },
    link(path, value) {
      if (path) {
        this.$router.push(path);
        return false;
      }
      if (value !== null && value !== undefined) {
        Bus.$emit("scroll", value);
      }
    },
    close() {
      this.boxStatic = false;
    },
    backTop() {
      document.getElementById("app").scrollTo({
        top: 0,
        behavior: "smooth",
      });
    },
    toggleData(url) {
      if (url !== "home") {
        this.arr = this.indexArr1;
        this.boxStatic = false;
        this.aniHeight = "180px";
      } else {
        this.boxStatic = true;
        this.arr = this.indexArr;
        this.aniHeight = "490px";
      }
    },
  },
  watch: {
    $route: {
      handler(val) {
        this.toggleData(val.name);
      },
      immediate: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.suspension {
  position: fixed;
  bottom: 110px;
  right: 0;
  z-index: 99;
  height: 300px;
  background: rgba($color: #ffffff, $alpha: 0.7);
  border-radius: 16px 0px 0px 16px;

  padding: 14px;



  .top {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .nav-item {
    position: relative;
    height: 100px;
    width: 48px;
    border-bottom: 1px solid #E8E8E8;

    .nav-btn {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      height: 100px;
      width: 48px;
      background-color: transparent;

      img {
        height: 31px;
      }

      .nav-btn-text {
        font-size: 12px;
        color: #333333;
        line-height: 14px;
        margin-top: 12px;
      }
    }
  }

  .nav-item:last-of-type {
    border-bottom: none;

  }

  .back {
    width: 56px;
    height: 56px;
    box-shadow: 0px 0px 7px 2px rgba(103, 114, 128, 0.06);
    background: transparent;
    border-radius: 50%;
    cursor: pointer;

    img {
      width: 100%;
      height: 100%;
    }
  }

  .box {
    margin-top: 50px;
    width: 114px;
    position: relative;
    height: 130px;

    .bg {
      width: 100%;
      height: 100%;
    }

    .close {
      display: block;
      cursor: pointer;
      position: absolute;
      right: 0;
      top: -20px;
    }
  }
}

.feedback {
  width: 330px;
  z-index: 9999;
  background-color: #fff;
  padding-top: 15px;

  .top {
    width: 100%;
    height: 25px;
    line-height: 25px;
    color: #333333;
    font-size: 16px;
    padding: 0 15px;
  }

  .bot {
    width: 100%;
    padding: 20px;

    .line {
      width: 100%;
      height: 36px;

      .input {
        width: 140px;
        height: 100%;
        display: inline-block;
        float: left;

        input {
          width: 100%;
          height: 100%;
          padding: 0 10px;
          border: 1px solid #f1f1f1;
          background-color: #f1f1f1;
        }
      }


    }

    .textarea {
      width: 100%;
      height: 80px;

      textarea {
        width: 100%;
        height: 100%;
        resize: none;
        background-color: #f1f1f1;
        border: 1px solid #f1f1f1;
        padding: 5px 10px;
      }
    }

    .sub-btn {
      width: 100%;
      text-align: center;
      border: none;
      color: #fff;
      font-size: 14px;
      margin-top: 20px;
      cursor: pointer;
    }
  }
}

.qrcode-box {
  padding: 15px;
  border-radius: 6px;
  position: absolute;
  top: -18px;
  right: 64px;
  z-index: 9999;
  width: 230px;
  background-color: #ffffff;

  .qrcode-img {
    width: 200px;
    height: auto;
  }
}

@media screen and (max-height: 950px) {
  .suspension {
    .hover.top {
      &:hover {
        .list {
          height: v-bind(aniHeight);
          padding: 28px 0;
        }
      }
    }

    .hover .list {
      height: 0;
      padding: 0;
      overflow: hidden;
      transition: height 0.3s;
    }
  }
}
</style>
